import { useSelector } from "react-redux";
import { paramsGetListaTipoCambioSUNAT } from "../../bussines/params/ListaTipoCambioSUNAT.params";
import { ListaTipoCambioSUNATDatasource } from "../../data/datasources/ListaTipoCambioSUNAT.datasource";
import { toast } from 'lib.front';

const useListaTiposCambio = () => {
   const usuario = useSelector((state: any) => state.auth.usuario);
   const apikey = usuario?.key;
   const enabled = !!apikey;

   const getListaTipoCambioSUNAT = async (params: paramsGetListaTipoCambioSUNAT) => {
      try {
         const datasource = new ListaTipoCambioSUNATDatasource(apikey);
         const response = await datasource.getListaTipoCambioSUNAT(params);
         return response;
      } catch (err) {
         const message = err instanceof Error ? err.message : String(err);
         toast.showError(message);
         return null;
      }
   };

   return { getListaTipoCambioSUNAT: getListaTipoCambioSUNAT, enabled };
};

export default useListaTiposCambio;